module.exports = __webpack_public_path__ + "img/shareImg4.a43c5e2e.png";